import classNames from 'classnames';
import OrderSummaryDetails from 'components/common/OrderSummaryDetails';
import { currencyFormat } from 'helpers/utils';
import { Card } from 'react-bootstrap';

interface OrderDetailsSummaryCardProps {
  className?: string;
  totalAmount: number;
  discountAmount: number;
  taxAmount: number;
  shippingCost: number;
  finalAmount: number;
}

const OrderDetailsSummaryCard = ({
  className,
  totalAmount,
  discountAmount,
  taxAmount,
  shippingCost,
  finalAmount
}: OrderDetailsSummaryCardProps) => {
  return (
    <Card className={classNames(className)}>
      <Card.Body>
        <Card.Title as="h3" className="mb-4">
          Summary
        </Card.Title>

        <div className="border-bottom border-translucent border-dashed mb-4">
          <OrderSummaryDetails
            totalAmount={totalAmount}
            discountAmount={discountAmount}
            taxAmount={taxAmount}
            shippingCost={shippingCost}
          />
        </div>
        <div className="d-flex justify-content-between">
          <h4 className="mb-0">Total :</h4>
          <h4 className="mb-">
            {currencyFormat(finalAmount, {
              minimumFractionDigits: 2,
              currency: 'SAR'
            })}
          </h4>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OrderDetailsSummaryCard;
